import { IMediaLayout } from 'types'
import { addLayoutTag } from '../../../utils/helpers'
import { parsePadding } from '../../../utils/layoutUtils'
import { useExplorerConfig } from '../../providers'
import { SMediaImage, SMediaPDF, SMediaVideo } from '../../scaled'
import EmptyLayout from '../EmptyLayout'

export default function MediaLayout({
  playVideo,
  mediaId,
  style,
  title,
}: Omit<IMediaLayout, 'type'> & { playVideo?: boolean }) {
  const { templateDocs } = useExplorerConfig()
  const media = templateDocs?.media.find(m => m.id === mediaId)

  if (!media) return <EmptyLayout type="media" />

  const { height, width } = style || {}
  const common = {
    mediaId,
    h: height,
    w: width,
    overflow: 'hidden',
    shrink: 1,
    ...parsePadding({ style, title }),
    ...addLayoutTag('media'),
  }

  switch (media.type) {
    case 'image':
      return <SMediaImage {...common} />
    case 'video':
      return <SMediaVideo {...common} controls paused={!playVideo} />
    case 'pdf':
      return <SMediaPDF {...common} />
  }
}
